module.exports = __webpack_public_path__ + "img/profile-man-16-min.06cf5236.jpg";